<template>
  <div>
    <h2 class="text-center">{{ $t('registerFormTitle') }}</h2>
    <ValidationObserver ref="observer" v-slot="{ passes }">
      <form class="form-horizontal homepage-register" method="post">
        <div class="form-group">
          <label for="name">{{ $t('registerFieldName') }}</label>
          <ValidationProvider name="name" rules="required" v-slot="{ errors }">
            <input v-model="registerForm.name" class="form-control" type="text" />
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>

        <div class="form-group">
          <label for="phone">{{ $t('registerFieldPhone') }}</label>
          <ValidationProvider name="phone" rules="required" v-slot="{ errors }">
            <input v-model="registerForm.phone" class="form-control" type="text" />
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>

        <div class="form-group">
          <label for="email">{{ $t('registerFieldEmail') }}</label>
          <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
            <input v-model="registerForm.email" class="form-control" type="text" />
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>

        <div class="form-group">
          <label for="currency">{{ $t('registerFieldCurrency') }}</label>
          <select
            @change="changeAmountOpt($event)"
            v-model="registerForm.currency"
            class="form-control"
          >
            <option
              v-for="(option, idx) in currencyOptions"
              v-bind:key="option.value"
              :value="option.value"
              :selected="idx == 0"
            >{{ option.value }}</option>
          </select>
        </div>

        <div class="form-group">
          <label for="amount">{{ $t('registerFieldAmount') }}</label>
          <span class="ml-3">
            <label>
              |
              <input type="checkbox" v-model="isManual" />
              {{ $t('calcOther') }}
            </label>
          </span>
          <select v-if="!isManual" v-model="registerForm.amount" id="amount" class="form-control">
            <option
              v-for="option in amountOptions"
              v-bind:key="option.value"
              :value="option.value"
            >{{ option.text }}</option>
          </select>

          <ValidationProvider
            v-if="isManual && registerForm.currency == 'IDR'"
            name="amount"
            rules="min_value:250000000"
            v-slot="{ errors }"
          >
            <input v-model="registerForm.amount" class="form-control" type="text" />
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>

          <ValidationProvider
            v-if="isManual && registerForm.currency == 'USD'"
            name="amount"
            rules="min_value:20000"
            v-slot="{ errors }"
          >
            <input v-model="registerForm.amount" class="form-control" type="text" />
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>

        <div class="form-group">
          <label for="time_period">{{ $t('registerFieldPeriod') }}</label>
          <select v-model="registerForm.timePeriod" id="time_period" class="form-control">
            <option
              v-for="option in timePeriodOptions"
              v-bind:key="option.value"
              :value="option.value"
            >{{ option.text }} {{ $t('registerYear')}}</option>
          </select>
        </div>

        <div class="form-group">
          <label for="investment_date">{{ $t('registerFieldStartDate') }}</label>

          <ValidationProvider name="investment_date" rules="required" v-slot="{ errors }">
            <input v-model="registerForm.investmentDate" id="investment_date" autocomplete="off" class="form-control datepick" type="text">
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>

        <div class="form-group">
          <div class="checkbox">
            <ValidationProvider
              name="terms"
              :rules="{ required: { allowFalse: false } }"
              v-slot="{ errors }"
            >
              <label for="tnc">
                <input v-model="registerForm.tnc" type="checkbox" />
                {{ $t('registerTncConfirm1') }}&nbsp;
                <a
                  href="#"
                  @click.prevent="openTncModal"
                >{{ $t('registerTncConfirm2') }}</a>
                &nbsp;
                {{ $t('registerTncConfirm3') }}
              </label>
              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="form-group mt-3">
          <button @click="passes(submitRegister)" type="button" class="btn btn-warning">{{ $t('registerSubmitButton') }}</button>
        </div>
      </form>
    </ValidationObserver>
    <TncModal v-if="includeTncModal" />
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";

import TncModal from "@/components/TncModal.vue";
import { mapState } from "vuex";

export default {
  name: "RegisterForm",
  props: {
    includeTncModal: Boolean,
    calcForm: Object
  },
  components: {
    TncModal,
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      isManual: false
    };
  },
  computed: {
    ...mapState([
      "registerForm",
      "currencyOptions",
      "timePeriodOptions",
      "amountOptions",
      "resetValidationErr"
    ])
  },
  watch: {
    resetValidationErr(newValue, oldValue) {
      this.clearError();
    }
  },
  methods: {
    openTncModal() {
      $("#tncModal").modal("show");
    },
    clearError() {
      this.$refs.observer.reset();
    },
    submitRegister() {
      let self = this
      let formatInvestmentDate = self.$options.filters.formatDate(this.registerForm.investmentDate);

      let objRegister = {
        "name": this.registerForm.name,
        "email": this.registerForm.email,
        "phone": this.registerForm.phone,
        "amount": this.registerForm.amount,
        "timePeriod": this.registerForm.timePeriod,
        "currency": this.registerForm.currency,
        "investmentDate": formatInvestmentDate
      }

      this.$axios.post('/api/v1/priority/user/register', objRegister)
      .then(response => {
        let new_user = response.data.data.user
        self.$store.dispatch('resetRegisterForm')
        self.$refs.observer.reset();
        this.$swal({
          text: this.$t('registerSuccess')
        });
      })
      .catch(err => {
        let err_message = err.message ? err.message : err
        this.$swal({
          text: err_message
        });
      })
    },
    changeAmountOpt(e) {
      let currency = e.target.value;
      if (currency == "IDR") {
        this.isManual = false;
      }
      this.$store.dispatch("changeCurrency", currency);
    }
  },
  mounted: function() {
    var self = this;
    $(".datepick").datepicker({
      dateFormat: 'dd M yy',
      minDate: new Date(),
      onSelect:function(selectedDate, datePicker) {
        let formatSelectedDate = self.$options.filters.formatDate(selectedDate);
        self.$store.dispatch('setInvestmentDate', selectedDate)
      }
    });
  }
};
</script>

<style scoped>
  #terms {
    font-size: 15px;
  }
  .datepicker {
    z-index:1151 !important;
  }
</style>